export const SUPPORTED_IMAGES = ['.jpg', '.png'];

export const MAX_FILE_SIZE = 2; // Units - MB
